import { DEFAULT_INVOICE_LANGUAGE } from '@features/invoices/constants/defaultInvoiceLanguage'
import { invoiceLanguageToLocale } from '@features/invoices/constants/invoiceLanguageToLocale'
import { ZervantLocale } from '@features/invoices/enums/zervantLocale'
import { isInvoiceLanguage } from '@features/invoices/utils/isInvoiceLanguage'

export const getDemoInvoiceLanguage = (language: string): ZervantLocale =>
  invoiceLanguageToLocale[isInvoiceLanguage(language) ? language : DEFAULT_INVOICE_LANGUAGE]
